import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { projectsEndpointIds } from 'root/src/shared/projects/projects.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
export const updateProjectAdminEndpoint = {
    [projectsEndpointIds.UPDATE_PROJECT_ADMIN]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                projectUrl: { type: 'string' },
                created: { type: 'string' },
            },
        },
        endpointType: otherEndpointType,
    },
};
